<template>

<div>
    <transition-group name="notifications" tag="ul" class="flex flex-col w-full max-w-480 fixed z-top inset-0 pointer-events-none justify-end mb-24">
        <notification
            v-for="notification in notifications"
            :key="notification.id"
            :id="notification.id"
            :type="notification.type"
            :message="notification.message"
            :title="notification.title"
            :notification="notification"
        ></notification>
    </transition-group>
</div>

</template>

<script>
import notification from './Notification.vue';
import {mapState} from 'pinia';
import {useNotificationsStore} from '../../state/modules/notifications';

export default {
    components: {
        notification
    },
    computed: {
        ...mapState(useNotificationsStore, ['notifications'])
    },
}
</script>

<style>
.notifications-item {
    transition: all 0.5s;
}
.notifications-enter {
  opacity: 0;
  transform: translateY(-30px);
}
.notifications-leave-to {
    opacity: 0;
}
.notifications-leave-active {
    position: absolute;
}
</style>
